import axios from 'axios';

export const proformsApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/proforms`,
    headers: {
        'Content-Type': 'application/json'
    }
})